import { t } from 'i18next';
import { Button } from 'primereact/button';
import arrowLeft from 'src/assets/images/arrow-left.gif';
import arrowRight from 'src/assets/images/arrow-right.gif';

export default function CallToActionComponent() {
  return <>
    <div
      style={
        {
          backgroundImage: 'url(/images/join_background.png)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }
      }
      className='flex flex-row justify-content-center align-items-center h-screen'
    >
      <div
        style={
          { 
            textAlign: 'center',
            height: '450px',
            backgroundImage: `url(${t('joinPage.centerImage')})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center'
          }
        }
        className='flex flex-column justify-content-end align-items-center w-full'
      >
        <div className='flex flex-row'>
          <img src={arrowLeft} width={'64px'}/>
          <img src={arrowRight} width={'64px'}/>
        </div>
        <Button
          label={t('9b5cdb7a-9cf0-4ab9-a445-31a5abbdc8c9')}
          className='flex btn-primary'
          style={{marginBottom: '48px'}}
          size='large'
          onClick={() => window.location.href = '#campaigns'}
          raised
          outlined
        />
      </div>
    </div>
  </>
}